import { useEffect, useRef, useState } from "react";
import { api, errorText } from "../../lib/api";
import { AreaPicker } from "./AreaPicker";
import { CourierOptions, courierKey } from "./CourierOptions";

let configPromise = null;
export const shippingConfig = () => (configPromise ||= api.get("/shipping/config").then(r => r.data).catch(() => { configPromise = null; return {enabled: false}; }));

export const useShippingSelection = cart => {
  const [config, setConfig] = useState(null), [area, setArea] = useState(null), [quote, setQuote] = useState(null), [selected, setSelected] = useState(""), [busy, setBusy] = useState(false), [error, setError] = useState("");
  const version = useRef(0);
  useEffect(() => { shippingConfig().then(setConfig); }, []);
  const cartKey = cart.map(i => `${i.sku}:${i.qty}`).join(",");
  useEffect(() => {
    setQuote(null); setSelected(""); setError("");
    if (!config?.enabled || !area) return;
    const run = ++version.current; setBusy(true);
    api.post("/shipping/rates", {area_id: area.id, postal_code: area.postal_code, items: cart})
      .then(r => { if (run !== version.current) return; setQuote(r.data); if (!r.data.pricing.length) setError("Tidak ada kurir otomatis untuk tujuan ini. Ongkir akan dikonfirmasi sales."); })
      .catch(err => run === version.current && setError(errorText(err)))
      .finally(() => run === version.current && setBusy(false));
  }, [config, area, cartKey]); // eslint-disable-line react-hooks/exhaustive-deps
  const option = quote?.pricing.find(p => courierKey(p) === selected) || null;
  const payload = {area_id: area?.id || "", area_name: area?.name || "", postal_code: area?.postal_code || "",
    ...(option ? {shipping_quote_id: quote.quote_id, courier_code: option.courier_code, courier_service_code: option.courier_service_code} : {})};
  return {config, area, setArea, quote, selected, setSelected, busy, error, option, payload};
};

export const ShippingSelector = ({ shipping }) => {
  const {config, area, setArea, quote, selected, setSelected, busy, error} = shipping;
  if (!config) return null;
  if (!config.enabled) return <p className="notice" data-testid="shipping-disabled-note">Cek ongkir otomatis belum aktif. Ongkir dikonfirmasi sales setelah pesanan dibuat.</p>;
  return <fieldset className="shipping-selector" data-testid="shipping-selector">
    <legend>Pengiriman</legend>
    <AreaPicker value={area} onChange={setArea}/>
    {area && <CourierOptions pricing={quote?.pricing || []} selected={selected} onSelect={setSelected} busy={busy} error={error}/>}
    {!area && <p className="muted" data-testid="shipping-pick-area-hint">Pilih kecamatan tujuan untuk melihat pilihan kurir dan tarif.</p>}
  </fieldset>;
};
